<template>
    <div>
        <el-dialog
            title="测试数据修正"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="800px">
            <div class="formContent">
                <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="120px">
                    <el-form-item label="测试收入" prop="id_doc_name">
                        <el-input maxlength="100" v-model="form.testIncome" placeholder="请输入测试收入金额" style="width: 400px"></el-input>
                    </el-form-item>
                    <el-form-item label="测试支出" prop="id_doc_number">
                        <el-input maxlength="100" v-model="form.testExpenses" placeholder="请输入测试支出金额" style="width: 400px"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                form: {
                    testIncome: '',
                    testExpenses: '',
                    id: ''
                },
                rules: {
                    testIncome: [{required: true, message:'请输入测试收入金额', trigger: 'blur'}],
                    testExpenses: [{required: true, message:'请输入测试支出金额', trigger: 'blur'}],
                },
            };
        },
        watch:{
            dialogVisible (val) {
                if(this.$refs['form'] && !val){
                    this.$refs['form'].resetFields()
                }
            },
        },
        methods:{
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let reqData = {
                            ...this.form,
                            testIncome: Number((this.form.testIncome*100).toFixed(0)),
                            testExpenses: Number((this.form.testExpenses*100).toFixed(0)),
                        }
                        this.$Axios._post({
                            url: this.$Config.apiUrl.recCompanyByTest,
                            params: {
                                ...reqData
                            },
                        })
                        .then(res => {
                            if(res.result.code == 0){
                                this.dialogVisible = false
                                this.$message.success('操作成功')
                                this.$emit('handlerSuccess');
                            }
                        })
                        .catch((error) => {
                            this.$message.error(error.result.message)
                        });
                    }
                })
                
            },
        }
    }
</script>

<style lang="scss" scoped>
    .tableTitle{
        font-size: 14px;
        color: #333333;
        font-weight: 700;
        margin: 24px 0;
        display: block;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
    .tips{
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        line-height: 22px;
    }
</style>